export default __webpack_public_path__ + "static/media/Hafez.a481eb71.jpg";